import { render, staticRenderFns } from "./TabSelector.vue?vue&type=template&id=97e8ee76"
import script from "./TabSelector.vue?vue&type=script&lang=js"
export * from "./TabSelector.vue?vue&type=script&lang=js"
import style0 from "./TabSelector.vue?vue&type=style&index=0&id=97e8ee76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports